import React from "react";

import DemographicsWidget from "@src/reporting/widgets/DemographicsWidget";
import DepartmentCapacityUseWidget from "@src/reporting/widgets/DepartmentCapacityUseWidget";
import GeographyDistributionWidget from "@src/reporting/widgets/GeographyDistributionWidget";
import PublicStatsSummaryWidget from "@src/reporting/widgets/PublicStatsSummaryWidget";
import RegistrationTimelineWidget from "@src/reporting/widgets/RegistrationTimelineWidget";
import styles from "@src/reporting/Reporting.module.styl";

const PublicStatisticsPage = () => (
  <main className={styles.page}>
    <PublicStatsSummaryWidget />
    <RegistrationTimelineWidget />

    <DemographicsWidget />
    <GeographyDistributionWidget
      initialLevel="DEPARTMENT"
      compact
      showMap={false}
      showTable={false}
    />
    <DepartmentCapacityUseWidget compact />
  </main>
);

export default PublicStatisticsPage;
